import { prettifyError } from 'zod/v4';
export const validateLog = (schema) => (res) => {
    const result = schema.safeParse(res.data);
    if (!result.success) {
        console.log(prettifyError(result.error));
    }
    return res;
};
